module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2015/april-310239a14d9091a0b313776fccbebf00.png";